var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('nav',{class:_vm.$style.breadcrumb,attrs:{"aria-label":_vm.$t('breadcrumb')}},[_c('ol',_vm._l((_vm.items),function(ref,index){
var to = ref.to;
var exact = ref.exact;
var text = ref.text;
return _c('li',{key:("breadcrumb-item-" + index)},[(index > 0)?_c('svg-icon',{attrs:{"name":"ic_arrow_next"}}):_vm._e(),_c('router-link',{attrs:{"exact":exact,"to":to}},[_vm._v(" "+_vm._s(text)+" ")])],1)}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }